let language = {
    FOOTER_QPSON_TITLE: "About",
    FOOTER_QPSON_JUMP_TITLE_1: "Connect Your Store",
    FOOTER_QPSON_JUMP_TITLE_2: "Print on Demand",
    FOOTER_QPSON_JUMP_TITLE_3: "Sell online without Inventory",
    FOOTER_QPSON_JUMP_TITLE_4: "Become a Partner",
    FOOTER_QPSON_JUMP_TITLE_Sell: "Sell Online",
    FOOTER_QPSON_JUMP_TITLE_CATALOG: "Product Catalog",
    FOOTER_QPSON_JUMP_TITLE_SHOPIFY: "Sell on Shopify",
    FOOTER_QPSON_JUMP_TITLE_WOOCOMMERCE: "Sell on WooCommerce",
    FOOTER_QPSON_JUMP_TITLE_API: "API",
    FOOTER_QPSON_JUMP_TITLE_SUPPORT: "Support",
};

export { language }